import { Component, OnInit, ViewChild } from '@angular/core';
import { Alert, AlertService, PaginatorFetcher, PaginatorFilters, TableComponent, TableConfig } from '@michelin/theme';
import { ActivatedRoute, Router } from '@angular/router';
import { FormBuilder, FormControl, FormGroup } from '@angular/forms';
import { PAGINATION_SIZES } from 'src/app/shared/utils/constants';
import { AutomakerService } from 'src/app/shared/services/automaker/automaker.service';
import { AutomakerDto } from 'src/app/shared/models/automaker/automaker-dto';
import { AutomakerPriceItemDto } from 'src/app/shared/models/automaker/automaker-price-item-dto';
import { ProductLineService } from 'src/app/shared/services/product-line/product-line.service';
import { ProductLineDto } from 'src/app/shared/models/product-line/product-line-dto';
import { forkJoin } from 'rxjs';

@Component({
    selector: 'app-list-automaker',
    templateUrl: './list-automaker-price-table.component.html',
    standalone: false
})
export class ListAutomakerPriceTableComponent implements OnInit {
  loading = false;
  automakerId: number;
  automaker: AutomakerDto;
  automakerPriceItem: AutomakerPriceItemDto;
  productLines: ProductLineDto[] = [];
  updatePriceTableRoute: string;

  formatCurrency = new Intl.NumberFormat('pt-BR', {
    style: 'currency',
    currency: 'BRL'
  });

  tableConfig: TableConfig<AutomakerPriceItemDto> = {
    paginator: {
      pageSize: 10,
      position: 'bottom',
      pageSizeOptions: PAGINATION_SIZES
    },
    columns: {
      part: { header: 'Part #', sortable: true, cell: (item) => item.automakerPrice.partNumber },
      cai: { header: 'CAI', sortable: true, cell: (item) => item.automakerPrice.product.cai },
      description: { header: 'Descrição', sortable: true, cell: (item) => item.automakerPrice.product.description },
      brand: { header: 'Marca', sortable: true, cell: (item) => item.automakerPrice.product.brand.name },
      // diameter: { header: 'Aro', sortable: true, cell: (item) => '' },
      // segment: { header: 'Segmento', sortable: true, cell: (item) => item.automakerPrice.product.segment },
      productLine: { header: 'LB', sortable: true, cell: (item) => item.automakerPrice.product.productLine.description },
      price: { header: 'Preço/UF', sortable: true, cell: (item) => this.formatCurrency.format(item.price || 0) + '/' + item.state.code },
      actions: { cell: 'actionsCell', header: ' ' }
    }
  };

  filterForm: FormGroup = this.form.group({
    automakerId: this.form.control('', { nonNullable: true }),
    part: this.form.control('', { nonNullable: true }),
    description: this.form.control('', { nonNullable: true }),
    cai: this.form.control('', { nonNullable: true }),
    productLine: this.form.control('', { nonNullable: true }),
    statusId: this.form.control('', { nonNullable: true })
  });

  fetcher: PaginatorFetcher<any>;

  @ViewChild(TableComponent, { static: true }) table: TableComponent<any>;

  constructor(
    private readonly form: FormBuilder,
    private readonly router: Router,
    private readonly activatedRoute: ActivatedRoute,
    private readonly alertService: AlertService,
    private readonly automakerService: AutomakerService,
    private readonly productLineService: ProductLineService
  ) {
    const automakerId = this.activatedRoute.snapshot.params['id'];
    this.fetcher = (filters: PaginatorFilters) => {
      filters.patchExtraFilters({ automakerId });
      return this.automakerService.searchPrice(filters);
    };
  }

  get productLine(): FormControl {
    return this.filterForm.get('productLine') as FormControl;
  }

  get filterValues(): any {
    return {
      partNumber: this.filterForm.value.part,
      description: this.filterForm.value.description,
      cai: this.filterForm.value.cai,
      productLineId: this.filterForm.value.productLine?.id
    };
  }

  codeDisplayName(data: any) {
    return data?.code || '';
  }

  applyFilter() {
    this.table.patchExtraFilters(this.filterValues, true);
  }

  resetFilter() {
    this.filterForm.reset();
    this.table.patchExtraFilters(this.filterValues, true);
  }

  ngOnInit() {
    this.loading = true;
    this.automakerId = this.activatedRoute.snapshot.params['id'];
    this.updatePriceTableRoute = `/automakers/${this.automakerId}/update-price-table`;

    this.form.group({
      automakerId: this.form.control(this.automakerId, { nonNullable: true }),
      part: this.form.control('', { nonNullable: true }),
      description: this.form.control('', { nonNullable: true }),
      cai: this.form.control('', { nonNullable: true }),
      productLine: this.form.control('', { nonNullable: true }),
      statusId: this.form.control('', { nonNullable: true })
    });

    forkJoin({
      productLines: this.productLineService.findAll(),
      automaker: this.automakerService.findById(this.automakerId)
    })
      .subscribe({
        next: (result) => {
          this.productLines = result.productLines;
          this.automaker = result.automaker;
        },
        error: () => this.alertService.showAlert({ type: 'critical', title: 'Ocorreu um erro ao recuperar as informações' } as Alert)
      })
      .add(() => (this.loading = false));
  }
}
